import {
    Button,
  Layout,
  Space,
  Typography,
} from 'antd';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import DataTable, { DataTableColumnProps } from '../../shared/DataTable/DataTable';
import DataTableButtonUtil from '../../shared/DataTable/DataTableButtonUtil';
import VerifiedStatementsOfRegistrationDTO from '../../../models/VerifiedStatementsOfRegistrationDTO';
import DataTableColumnUtil from '../../shared/DataTable/DataTableColumnUtil';
import PublicReportsApiService from '../../../api/PublicReportsApiService';
import { ArrowLeftOutlined } from '@ant-design/icons';
import HistoryUtil from '../../../utils/HistoryUtil';
import Routes from '../../../consts/Routes';
import DataTableCellRendererUtil from '../../shared/DataTable/DataTableCellRendererUtil';
import moment from 'moment';

const { Content } = Layout;

interface VerifiedStatementsOfRegistrationProps {

}

interface VerifiedStatementsOfRegistrationState {
  tableColumns: DataTableColumnProps<VerifiedStatementsOfRegistrationDTO>[];
}

class VerifiedStatementsOfRegistration extends React.Component<RouteComponentProps<VerifiedStatementsOfRegistrationProps>,
  VerifiedStatementsOfRegistrationState> {

  constructor(props: RouteComponentProps<VerifiedStatementsOfRegistrationProps>) {
    super(props);

    this.state = {
      tableColumns: this.getTableColumns()
    };
  }

  render() {
    const actionButtons = [];
    actionButtons.push(DataTableButtonUtil.Reset());
    return (
      <Content className="content-pad">
        <DataTable
          globalSearch={true}
          serverSide={true}
          buttonBar={actionButtons}
          columns={this.state.tableColumns}
          tableProps={{
            rowKey: 'id',
            sortDirections: ['ascend', 'descend'],
            locale: { emptyText: 'No Reports Currently Match Your Filter' }
          }}
          fetchData={{
            fetch: function (tableRequest) {
              return PublicReportsApiService.getVSR(tableRequest)
                .then(res => {
                  res.results?.forEach(r => {
                    if (r.filedOn) {
                      r.filedOn = moment.utc(r.filedOn).local();
                    }
                  });
                  return res;
                });
            },
            failureMessage: 'Failed to retrieve public reports'
          }}
          styleOptions={{ compact: true, alternatingRowHighlight: true }}
          title={
            <Button type="link" onClick={() => HistoryUtil.push(Routes.generate(Routes.PUBLIC_REPORTS))}>
              <Typography.Title level={4}>
                <Space size="large">
                  <ArrowLeftOutlined className="public-report-links"/> Verified Statements of Registration
                </Space>
              </Typography.Title>
            </Button>
          }
        />
      </Content>
    );
  }

  private getTableColumns = (): DataTableColumnProps<VerifiedStatementsOfRegistrationDTO>[] => {
    const filedOn = DataTableColumnUtil.Date<VerifiedStatementsOfRegistrationDTO>('Filed On', 'filedOn');
    filedOn.render = DataTableCellRendererUtil.DateAndTime;
    return [
      DataTableColumnUtil.Text('Committee Code', 'committeeCode', null, { defaultSortOrder: 'descend' }),
      DataTableColumnUtil.Address('Committee', 'committeeName',
        (c) => ({
          name: c.committeeName,
          line1: c.committeeAddress1,
          line2: c.committeeAddress2,
          city: c.committeeCity,
          state: c.committeeState,
          zip: c.committeeZip
        })),
      filedOn,
      DataTableColumnUtil.Buttons('fileName',
        [
          { text: 'View', onClick: (rowData) => window.open(rowData.fileUrl || '') },
        ])
    ];
  }
}

export default VerifiedStatementsOfRegistration;